/* Alumka theme JS */
(function () {
  // Mobile nav
  var burger = document.querySelector('.site-header__burger');
  if (burger) {
    burger.addEventListener('click', function () {
      var header = document.querySelector('.site-header');
      var open = header.classList.toggle('nav-open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  // Quantity steppers
  document.querySelectorAll('.qty').forEach(function (qty) {
    var input = qty.querySelector('input');
    qty.querySelectorAll('button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var v = parseInt(input.value || '1', 10);
        v += btn.dataset.dir === 'up' ? 1 : -1;
        input.value = Math.max(1, v);
        if (input.form && input.closest('.cart-table')) input.form.submit();
      });
    });
  });

  // Product gallery thumbs
  document.querySelectorAll('.product__thumbs button').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var main = document.querySelector('.product .main-img img');
      if (!main) return;
      main.src = btn.dataset.src;
      main.srcset = '';
      document.querySelectorAll('.product__thumbs button').forEach(function (b) {
        b.setAttribute('aria-current', b === btn ? 'true' : 'false');
      });
    });
  });

  // Variant picker -> update price / availability / hidden id
  var picker = document.querySelector('[data-variant-json]');
  if (picker) {
    var variants = JSON.parse(picker.querySelector('script').textContent);
    var selects = picker.querySelectorAll('select[data-option-index]');
    var idInput = document.querySelector('form[data-product-form] input[name="id"]');
    var priceEl = document.querySelector('[data-price]');
    var btn = document.querySelector('[data-add-btn]');

    function currentVariant() {
      var opts = Array.prototype.map.call(selects, function (s) { return s.value; });
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }
    function fmt(cents) {
      return (window.Alumka && window.Alumka.moneyFormat || 'Rs {{amount}}')
        .replace(/\{\{\s*amount\s*\}\}/, (cents / 100).toLocaleString('en-LK', { minimumFractionDigits: 2 }));
    }
    selects.forEach(function (s) {
      s.addEventListener('change', function () {
        var v = currentVariant();
        if (!v) return;
        idInput.value = v.id;
        if (priceEl) priceEl.textContent = fmt(v.price);
        if (btn) {
          btn.disabled = !v.available;
          btn.textContent = v.available ? btn.dataset.labelAdd : btn.dataset.labelSoldout;
        }
        var url = new URL(window.location);
        url.searchParams.set('variant', v.id);
        history.replaceState(null, '', url);
      });
    });
  }

  // Scroll reveals — tag grid items & section heads, stagger siblings
  var motionOK = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (motionOK && 'IntersectionObserver' in window) {
    var targets = document.querySelectorAll('.card, .cat-tile, .prop, .section-head, .catalog-cta .plate, .product__specs .plate');
    targets.forEach(function (el) {
      el.classList.add('reveal');
      var sibs = el.parentElement ? Array.prototype.filter.call(el.parentElement.children, function (c) { return c.classList.contains('reveal'); }) : [];
      var i = sibs.indexOf(el);
      if (i > -1) el.style.transitionDelay = Math.min(i % 8, 6) * 70 + 'ms';
    });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.1 });
    targets.forEach(function (el) { io.observe(el); });
  }

  // Collection sort
  var sort = document.querySelector('[data-sort]');
  if (sort) {
    sort.addEventListener('change', function () {
      var url = new URL(window.location);
      url.searchParams.set('sort_by', sort.value);
      window.location = url;
    });
  }

  // Cart drawer
  var drawer = document.querySelector('[data-cart-drawer]');
  var backdrop = document.querySelector('[data-drawer-backdrop]');
  if (drawer && backdrop) {
    function openDrawer() {
      drawer.classList.add('open');
      backdrop.classList.add('open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      var closeBtn = drawer.querySelector('[data-drawer-close]');
      if (closeBtn) closeBtn.focus();
    }
    function closeDrawer() {
      drawer.classList.remove('open');
      backdrop.classList.remove('open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
    document.querySelectorAll('[data-drawer-open]').forEach(function (b) { b.addEventListener('click', openDrawer); });
    document.querySelectorAll('[data-drawer-close], [data-drawer-close-link]').forEach(function (b) { b.addEventListener('click', closeDrawer); });
    backdrop.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('open')) closeDrawer(); });

    // Auto-submit the drawer's update form when a qty stepper or input changes
    var form = drawer.querySelector('[data-drawer-form]');
    if (form) {
      form.addEventListener('change', function (e) {
        if (e.target.matches('input[name="updates[]"]')) form.submit();
      });
    }
  }
})();
